/**
 * Application Version Configuration
 * 
 * This file provides centralized version tracking for the NovaMed Clinic Platform.
 * Update this when releasing new versions.
 * 
 * Version format: MAJOR.MINOR.PATCH
 * - MAJOR: Breaking changes or major feature releases
 * - MINOR: New features, backwards compatible
 * - PATCH: Bug fixes and minor improvements
 */

// Import version from package.json
import packageJson from '../../package.json';

export const APP_VERSION = packageJson.version;
export const APP_NAME = 'Nimbus-OS';
export const COPYRIGHT_YEAR = new Date().getFullYear();

// Full version string for display
export const getVersionString = () => `V${APP_VERSION}`;

// Footer text
export const getFooterText = () => `Powered by ®${APP_NAME}`;
